// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ToolsMenu-cls1__db709cf58a3aaf28d1ba{/*!*/}.ToolsMenu-cls2___3c7139823dfe246337f{margin:8px;display:flex;align-items:center;justify-content:center;height:20px;width:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ToolsMenu-cls1__db709cf58a3aaf28d1ba",
	"cls2": "ToolsMenu-cls2___3c7139823dfe246337f ToolsMenu-cls1__db709cf58a3aaf28d1ba"
};
export default ___CSS_LOADER_EXPORT___;
